<div class="row" [formGroup]="form" id="form">

  <div class="col-6" id="first">
    <div class="row bg-cust-blue text-white">
      <div class="col-9 ny-auto">
        <h6 class="m-2">Verify</h6>
      </div>
      <div class="col-3 text-right">
        <button class="btn btn-link btn-xs mr-3 sr-only" (click)="normal()">N</button>
        <button class="btn btn-link btn-xs  sr-only" (click)="crisis()">C</button>
      </div>
    </div>
    <div class="row mt-3 crisis">
      <div class="col-3 text-right two-row-lbl">
        <div *ngIf="!isCrisis">
          <label>หมายเลขบัตรประชาชน/</label>
          <br>
          <label>เลขประจำตัวผู้เสียภาษี</label>
        </div>
        <div *ngIf="isCrisis">
          <label>หมายเลขบัตรประชาชน/</label>
          <br>
          <label>เลขประจำตัวผู้เสียภาษี/</label>
          <br>
          <label>หมายเลขพาสปอร์ต</label>
        </div>
      </div>
      <div class="col-3">
        <input type="text" class="{{isCrisis ? 'form-control' :  'form-control number'}}" [disabled]="crm06.IDNo != null && crm06.IDNo != ''" [(ngModel)]="idNoSearchDROS" [ngModelOptions]="{standalone: true}">
      </div>
      <div class="col-3 text-right">
        <label>เลขที่บัญชี</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control number" [disabled]="crm06.IDNo != null && crm06.IDNo != ''" [(ngModel)]="accNoSearchDROS" [ngModelOptions]="{standalone: true}">
      </div>
    </div>

    <div class="row mt-2 crisis" *ngIf="isCrisis && (crm06.IDNo == null || crm06.IDNo == '')">
      <div class="col-12 text-right">
        <button class="btn btn-primary" (click)="getDrosContact(idNoSearchDROS, null, accNoSearchDROS)">ค้นหา</button>
      </div>
    </div>

    <div class="row mt-3 crisis">
      <div class="col-3 text-right">
        <label>ที่อยู่ที่ให้ไว้กับ สง.</label>
      </div>
      <div class="col-9">
        <textarea class="form-control" rows="3" readonly>{{crm06.AddressRegister}}</textarea>
      </div>
    </div>
    <div class="row mt-3 crisis">
      <div class="col-3 text-right">
        <label>ที่อยู่ที่สามารถติดต่อได้</label>
      </div>
      <div class="col-9">
        <textarea class="form-control" rows="3" readonly>{{crm06.AddressContact}}</textarea>
      </div>
    </div>

    <div class="row mt-3 crisis">
      <div class="col-3 text-right">
        <label>จำนวนบัญชีเงินฝาก</label>
      </div>
      <div class="col-3">
        <div class="input-group">
          <input type="text" class="form-control" disabled [(ngModel)]="crm06.NumberOfDepositAccounts" [ngModelOptions]="{standalone: true}">
          <div class="input-group-append">
            <button class="btn btn-primary" (click)="viewAccountList()">
              <span class="fa fa-list-ol"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-3 text-right">
        <label>เบอร์โทรศัพท์ที่ให้ไว้กับ สง.</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" disabled [(ngModel)]="crm06.PhoneNo" [ngModelOptions]="{standalone: true}">
      </div>
    </div>

    <div class="row mt-3 crisis">
      <div class="col-3 text-right">
        <label>ผู้มีส่วนได้เสีย</label>
      </div>
      <div class="col-9">
        <select class="form-control" formControlName="dpa_stakeholderid">
          <option value="">เลือก</option>
          <option *ngFor="let s of stakeHolderList" [value]="s.dpa_stakeholdersid">
            {{s.dpa_name}}
          </option>
        </select>
      </div>
    </div>

    <div class="row mt-3 crisis">
      <div class="col-11 mx-auto text-center">
        <label>Verify ตัวตนผ่าน</label>
        <label class="ml-3">
          <input type="checkbox" disabled [checked]="isNDID">
          NDID/Mobile ID
        </label>
        <label class="ml-3">
          <input type="checkbox" disabled [checked]="isDOPA">
          DOPA
        </label>
        <label class="ml-3">
          <input type="checkbox" disabled [checked]="isAgentBank">
          Agent Bank
        </label>
      </div>
    </div>
    <hr class="crisis">

    <!-- <div class="row mt-3">
      <div class="col-3 text-right">
        <label class="">ประเภทบุคคล</label>
      </div>
      <div class="col-9">
        <select class="form-control" formControlName="dpa_personaltypeid">
          <option value="">เลือก</option>
          <option *ngFor="let p of personalTypeList" [value]="p.dpa_personaltypeid">
            {{p.dpa_name}}
          </option>
        </select>
      </div>
    </div> -->

    <div class="row mt-3">
      <div class="col-3 text-right">
        <label class="required">หมายเลขโทรศัพท์</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control contact-input number" formControlName="telephone1" readonly>
        <span class="text-danger"
          *ngIf="(formControl.telephone1.touched || submitted) && formControl.telephone1.errors?.required">
          กรุณาระบุหมายเลขโทรศัพท์
        </span>
      </div>
      <div class="col-3 text-right">
        <label>หมายเลขโทรศัพท์ที่ติดต่อได้</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control contact-input number" formControlName="dpa_otherphone">
      </div>
    </div>

    <div class="row mt-3">

      <div class="col-3 text-right">
        <label>อีเมล</label>
      </div>
      <div class="col-9">
        <input type="email" class="form-control contact-input" formControlName="emailaddress1">
        <!-- <span class="text-danger"
            *ngIf="(formControl.emailaddress1.touched || submitted) &&
            (formControl.emailaddress1.errors?.email && email != '')">
            อีเมลไม่ถูกต้อง
          </span> -->
        <span class="text-danger"
          *ngIf="form.get('emailaddress1').invalid && (form.get('emailaddress1').dirty || form.get('emailaddress1').touched)">
          อีเมลไม่ถูกต้อง
        </span>
      </div>
    </div>

    <div class="row mt-3">

      <div class="col-3 text-right">
        <label class="">ชื่อ</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control contact-input" formControlName="firstname" readonly>
        <!-- <span class="text-danger"
          *ngIf="(formControl.firstname.touched || submitted) && formControl.firstname.errors?.required">
          กรุณาระบุชื่อ
        </span> -->
      </div>
      <div class="col-3 text-right">
        <label class="">นามสกุล</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control contact-input" formControlName="lastname" readonly>
        <!-- <span class="text-danger"
          *ngIf="(formControl.lastname.touched || submitted) && formControl.lastname.errors?.required">
          กรุณาระบุนามสกุล
        </span> -->
      </div>
    </div>

    <!-- <div class="row mt-3">
      <div class="col-3 text-right">
        <label class="required">รายละเอียด</label>
      </div>
      <div class="col-9">
        <textarea class="form-control" rows="3"></textarea>
      </div>

    </div> -->

    <div class="row mt-3">

      <div class="col-3 text-right">
        <label>วันที่สร้าง Contact</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" readonly value="{{createContactOn | thaidate:'short'}}">
      </div>
      <div class="col-3 text-right">
        <label>วันที่แก้ไข Contact</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" readonly value="{{modifyContactOn | thaidate:'short'}}">
      </div>
    </div>

    <div class="row mt-3">

      <div class="col-3 text-right">
        <label>ผู้สร้างข้อมูล Contact</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" readonly value="{{createContactBy}}">
      </div>
      <div class="col-3 text-right">
        <label>ผู้แก้ไขข้อมูล Contact</label>
      </div>
      <div class="col-3">
        <input type="text" class="form-control" readonly value="{{modifyContactBy}}">
      </div>
    </div>
  </div>
  <div class="col-6" id="second">
    <div class="row">
      <div class="col-12 bg-cust-blue text-white pt-2">
        <h6>รายงานการติดต่อ - Call Center</h6>
      </div>
    </div>

    <div class="row">
      <div class="col-10">
        <div class="row mt-3">
        </div>
        <div class="row mt-3">
          <div class="col-3 text-right">
            <label class="required">ช่องทางการติดต่อ</label>
          </div>
          <div class="col-3">
            <select class="form-control" formControlName="dpa_casechannelid">
              <option selected value="">กรุณาเลือก</option>
              <option *ngFor="let c of caseChannelList" [value]="c.dpa_casechannelid">
                {{c.dpa_name}}
              </option>
            </select>
            <span class="text-danger"
              *ngIf="(formControl.dpa_casechannelid.touched || submitted) && formControl.dpa_casechannelid.errors?.required">
              กรุณาระบุช่องทางการติดต่อ
            </span>
          </div>

          <div class="col-3 text-right">
            <label class="required">สถานะรายงานการติดต่อ</label>
          </div>
          <div class="col-3">
            <select class="form-control" formControlName="dpa_casestatusid" (change)="onCaseStatusChange()">
              <option selected value="">กรุณาเลือก</option>
              <option *ngFor="let c of caseStatusList" [value]="c.dpa_casestatusid">
                {{c.dpa_name}}
              </option>
            </select>
            <span class="text-danger"
              *ngIf="(formControl.dpa_casestatusid.touched || submitted) && formControl.dpa_casestatusid.errors?.required">
              กรุณาระบุสถานะรายงานการติดต่อ
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-3 text-right">
            <label class="required">ประเภทรายงานการติดต่อ</label>
          </div>
          <div class="col-9">
            <select class="form-control" (change)="onCaseTypeChange()" formControlName="dpa_casetypeid">
              <option selected value="">กรุณาเลือก</option>
              <option *ngFor="let c of caseTypeList" [value]="c.dpa_casetypeid">
                {{c.dpa_name}}
              </option>
            </select>
            <span class="text-danger"
              *ngIf="(formControl.dpa_casetypeid.touched || submitted) && formControl.dpa_casetypeid.errors?.required">
              กรุณาระบุประเภทรายงานการติดต่อ
            </span>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-3 text-right">
            <label class="required">หัวข้อการติดต่อ</label>
          </div>
          <div class="col-9">
            <select class="form-control" (change)="onCaseSubTypeChange()" formControlName="dpa_casesubtypeid">
              <option selected value="">กรุณาเลือก</option>
              <option *ngFor="let c of caseSubTypeList" [value]="c.dpa_casesubtypeid">
                {{c.dpa_name}}
              </option>
            </select>
            <span class="text-danger"
              *ngIf="(formControl.dpa_casesubtypeid.touched || submitted) && formControl.dpa_casesubtypeid.errors?.required">
              กรุณาระบุหัวข้อการติดต่อ
            </span>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-3 text-right">
            <label class="required">หัวข้อย่อย</label>
          </div>
          <div class="col-9">
            <select class="form-control" formControlName="dpa_casesubtypedetailid">
              <option selected value="">กรุณาเลือก</option>
              <option *ngFor="let c of caseSubTypeDetailList" [value]="c.dpa_casesubtypedetailid">
                {{c.dpa_name}}
              </option>
            </select>
            <span class="text-danger"
              *ngIf="(formControl.dpa_casesubtypedetailid.touched || submitted) && formControl.dpa_casesubtypedetailid.errors?.required">
              กรุณาระบุหัวข้อย่อย
            </span>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-3 text-right">
            <label class="required">ระดับความสำคัญ</label>
          </div>
          <div class="col-9">
            <select class="form-control" formControlName="dpa_caseseverityid">
              <option selected value="">กรุณาเลือก</option>
              <option *ngFor="let c of caseSeverityList" [value]="c.dpa_caseseverityid">
                {{c.dpa_name}}
              </option>
            </select>
            <span class="text-danger"
              *ngIf="(formControl.dpa_caseseverityid.touched || submitted) && formControl.dpa_caseseverityid.errors?.required">
              กรุณาระบุระดับความสำคัญ
            </span>
          </div>
        </div>

        <div class="row mt-3">

          <div class="col-3 text-right">
            <label class="required">รายละเอียด</label>
          </div>
          <div class="col-9">
            <textarea class="form-control" rows="3" formControlName="description"></textarea>
            <span class="text-danger"
              *ngIf="(formControl.description.touched || submitted) && formControl.description.errors?.required">
              กรุณาระบุรายละเอียด
            </span>
          </div>

        </div>
        <div class="row mt-3">
          <div class="col-3 text-right">
            <label class="{{isResolvedRequired ? 'required' : ''}}">ตอบ</label>
          </div>
          <div class="col-9">
            <textarea class="form-control" rows="3" formControlName="dpa_resolution"></textarea>
            <span class="text-danger"
          *ngIf="(formControl.dpa_resolution.touched || submitted) && (formControl.dpa_resolution.value == null ||formControl.dpa_resolution.value.trim().length == 0) && isResolvedRequired">
          กรุณาระบุคำตอบ
        </span>
          </div>

        </div>

        <div class="row mt-3">
          <div class="col-3 text-right">
            <label class="{{isRemarkRequired ? 'required' : ''}}">หมายเหตุ</label>
          </div>
          <div class="col-9">
            <textarea class="form-control" rows="3" formControlName="dpa_remark"></textarea>
            <span class="text-danger"
              *ngIf="(formControl.dpa_remark.touched || submitted) && formControl.dpa_remark.value.trim().length == 0 && isRemarkRequired">
              กรุณาระบุหมายเหตุ
            </span>
          </div>

        </div>

        <div class="row mt-3" >
          <div class="col-3">
          </div>
          <div class="col-8" >
           <label>
            <input type="checkbox"  formControlName="dpa_allowemail"  [checked]="dpa_allowemail" (change)="dpa_allowemail = !dpa_allowemail"> ยินยอมให้ติดต่อผ่าน E-mail ที่ท่านแจ้งไว้
            </label>
          </div>   
          <div class="col-3">
          </div>
          <div class="col-8" >
           <label >
            <input type="checkbox"  formControlName="dpa_allowsms"  [checked]="dpa_allowsms" (change)="dpa_allowsms  = !dpa_allowsms "> ยินยอมให้ติดต่อผ่านหมายเลขโทรศัพท์ที่ท่านแจ้งไว้
           </label> 
        </div>        
        <div class="col-3">
        </div>
        <div class="col-8" >
         <label > <!--formControlName="dpa_allowsms"  [checked]="dpa_allowsms " (change)="dpa_allowsms  = !dpa_allowsms "-->
          <input id="ra1" type="radio" formControlName="dpa_pdpa_flag"  > ยอมรับนโยบายความเป็นส่วนตัว
         </label>
         <label >
          <input id="ra2" type="radio"  > ไม่ยอมรับนโยบายความเป็นส่วนตัว
         </label>
        </div>  
        <div class="row mt-3">

          <div class="col-3 text-right">
            <label>วันที่สร้าง</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" readonly value="{{createdon | thaidate:'short'}}">
          </div>
          <div class="col-3 text-right">
            <label>วันที่ Update ล่าสุด</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" readonly value="{{modifiedon | thaidate:'short'}}">
          </div>
        </div>

        <div class="row mt-3">

          <div class="col-3 text-right">
            <label>ผู้สร้างข้อมูล</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" readonly value="{{createBy}}">
          </div>
          <div class="col-3 text-right">
            <label>ผู้แก้ไขข้อมูลล่าสุด</label>
          </div>
          <div class="col-3">
            <input type="text" class="form-control" readonly value="{{modifiedBy}}">
          </div>
        </div>

        <!-- <div class="row mt-3">

          <div class="col-12 input-group">
            <button class="btn btn-info">
              <span class="fa fa-paperclip"></span>
              Attatch File
            </button>
            <input type="text" class="form-control" readonly>
          </div>
        </div> -->


      </div>
      <div class="col-2">
        <button class="btn btn-primary mt-3" (click)="openKm()" id="btnKm">
          <img src="../../assets/images/knowledge.png">
          <br>
          <span>KM</span>
        </button>
      </div>

      <!-- <div class="col-4 pt-3">
        <div class="bg-cust-blue overflow-auto"
          style="border-bottom-left-radius: 1rem; border-top-left-radius: 1rem; height: 90%;">
          <div class="row mt-3">
            <div class="col-12 text-center mt-3">
              <h5 class="text-white">ค้นหาตาม Keyword</h5>
            </div>
            <div class="col-12 input-group p-3">
              <input type="search" class="form-control search-field" placeholder="Search" id="kmCriContact"
                (keyup.enter)="filterKm()">
              <div class="input-group-append">
                <button class="btn btn-primary" (click)="filterKm()">
                  <span class="fa fa-search"></span>
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-11 p-3 m-3 text-white" style="border-radius: 1rem; border: 1px solid white;">
              <ol class="pl-3 km-type">
                <li class="mb-3" (click)="filterByType(1)">ข้อมูลเกี่ยวกับสถาบันคุ้มครองเงินฝาก (องค์กร)</li>
                <li class="mb-3" (click)="filterByType(2)">ข้อมูลเกี่ยวกับระบบคุ้มครองเงินฝาก</li>
                <li class="mb-3" (click)="filterByType(3)">ข้อมูลเกี่ยวกับการคุ้มครองเงินฝาก (วงเงินผลิตภัณฑ์
                  สง.ที่คุ้มครอง)</li>
                <li class="mb-3" (click)="filterByType(4)">กระบวนการจ่ายคืน</li>
                <li class="mb-3" (click)="filterByType(5)">กระบวนการชำระบัญชี</li>
                <li class="mb-3" (click)="filterByType(6)">ความรู้ทั่วไปทางการเงิน</li>
                <li class="mb-3" (click)="filterByType(7)">อื่นๆ</li>
              </ol>
            </div>
          </div>
          <div class="row">
            <div *ngFor="let km of showingKBList">
              <div class="col-11 text-white">
                <b>{{km.dpa_name}}:</b>
              </div>
              <div class="col-11 p-3 m-3 text-white km-content" [innerHTML]="km.dpa_content"></div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>

</div>
<div class="row mt-5">
  <div class="col-12 text-center">
    <button type="button" class="btn btn-info m-2" (click)="save()" [disabled]="isEndCase">
      <span class="fa fa-check"></span>
      บันทึก
    </button>
    <button type="button" class="btn btn-info m-2" (click)="save(true)" [disabled]="isEndCase">
      <span class="fa fa-check"></span>
      บันทึกและปิด
    </button>
    <button type="button" class="btn btn-info m-2" *ngIf="role.dpa_button_reaasigncase" (click)="forward()" [disabled]="isEndCase">
      <span class="fa fa-paper-plane"></span>
      ส่งต่อ
    </button>
    <button type="button" class="btn btn-info m-2" (click)="close()">
      <span class="fa fa-times"></span>
      ปิด
    </button>
  </div>
</div>

<!-- Modal accountList-->
<div class="modal fade" id="accountListModal" tabindex="-1" role="dialog" aria-labelledby="accountListModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="accountListModalLabel">รายการบัญชีเงินฝาก</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12 table-responsive">
            <table id="accountTable" style="width:100%" class="table table-bordered table-hover result-table">
              <thead>
                <tr>
                  <th>ธนาคาร</th>
                  <th>เลขที่บัญชื</th>
                  <th>ชื่อบัญชี</th>
                  <!-- <th>รหัสสาขา</th> -->
                  <th>สถานะบัญชี</th>
                  <th>ประเภทบัญชี</th>
                </tr>
              </thead>
              <tbody>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-info" data-dismiss="modal">ปิด</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Modal Forward-->
<div class="modal fade" id="forwardModal" tabindex="-1" role="dialog" aria-labelledby="forwardModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="forwardModalLabel">ส่งต่อรายงานการติดต่อ</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-5 text-right">
            <label class="required">ทีม</label>
          </div>
          <div class="col-7">
            <select class="form-control" [(ngModel)]="forwardTeam" (change)="onForwardTeamChange()">
              <option value="" selected>เลือก</option>
              <option *ngFor="let t of teamList" [value]="t.dpa_callcenterteamid">
                {{t.dpa_name}}
              </option>
            </select>
            <span class="text-danger" *ngIf="submittedForward && forwardTeam == ''">
              กรุณาเลือก ทีม
            </span>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label class="">ผู้ใช้งาน</label>
          </div>
          <div class="col-7">
            <select class="form-control" [(ngModel)]="userIdReceive">
              <option value="">เลือก</option>
              <option *ngFor="let a of userList" [value]="a.dpa_customwebuserid">
                {{a.dpa_name}}
              </option>
            </select>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-5 text-right">
            <label class="required">หมายเหตุ</label>
          </div>
          <div class="col-7">
            <input type="text" class="form-control" [(ngModel)]="forwardRemark">
            <span class="text-danger" *ngIf="submittedForward && forwardRemark == ''">
              กรุณาระบุ หมายเหตุ
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-center mt-5">
            <button type="button" class="btn btn-info mr-2" (click)="confirmForward()">OK</button>
            <button type="button" class="btn btn-info ml-2" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/customer-profile/customer-profile.component.html